import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { IconButton, TextField } from 'seagull';
import { Edit } from 'seagull/icons';
import { DefaultValuePopover } from '~/components/AgreementStudioPage/TemplateVariables/DefaultValuePopover/DefaultValuePopover';
import { useTextFieldVariableIntegration } from '~/components/AgreementStudioPage/TemplateVariables/hooks/useTextFieldVariableIntegration';
import { VariableFieldAdornment } from '~/components/AgreementStudioPage/TemplateVariables/VariableFieldAdornment/VariableFieldAdornment';
import { VariablePickerPopover } from '~/components/AgreementStudioPage/TemplateVariables/VariablePickerPopover/VariablePickerPopover';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
export const PackageNameCellContent = (param)=>{
    let { packageName, packageId, draft, setDraft } = param;
    const form = useForm({
        mode: 'all',
        defaultValues: {
            packageName
        }
    });
    const { t } = useLocaleKeys('pages.draftsDashboard.editPackageName');
    const inputRef = useRef(null);
    const setNameValue = useCallback((value)=>form.setValue('packageName', value), [
        form
    ]);
    const { enabled, inputProps, adornmentRef, fieldAdornmentProps, pickerPopoverProps, defaultValuePopoverProps } = useTextFieldVariableIntegration(inputRef, setNameValue);
    const onChange = (packageName)=>{
        if (!packageId) return;
        setDraft(draft.setPackageName(packageId, packageName));
    };
    return /*#__PURE__*/ _jsxs(FormProvider, _object_spread_props(_object_spread({}, form), {
        children: [
            /*#__PURE__*/ _jsx(Controller, {
                control: form.control,
                name: "packageName",
                rules: {
                    validate: (n)=>!!n && n.length > 0
                },
                render: (renderProps)=>{
                    const controllerProps = connectControllerToTextField(renderProps);
                    return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                        bi: {
                            name: 'package_name'
                        },
                        collapseHelperText: false
                    }, controllerProps), {
                        inputRef: inputRef,
                        autoFocus: true,
                        label: t.packageName(),
                        testId: "edit-package-name-modal",
                        onChange: (e)=>{
                            onChange(e.target.value);
                            controllerProps.onChange(e);
                        },
                        onKeyDown: inputProps === null || inputProps === void 0 ? void 0 : inputProps.onKeyDown,
                        onClick: inputProps === null || inputProps === void 0 ? void 0 : inputProps.onClick,
                        InputProps: enabled ? {
                            endAdornment: /*#__PURE__*/ _jsx("span", {
                                ref: adornmentRef,
                                children: /*#__PURE__*/ _jsx(VariableFieldAdornment, _object_spread({}, fieldAdornmentProps))
                            })
                        } : undefined
                    }));
                }
            }),
            enabled && /*#__PURE__*/ _jsx(VariablePickerPopover, _object_spread({}, pickerPopoverProps)),
            enabled && /*#__PURE__*/ _jsx(DefaultValuePopover, _object_spread({}, defaultValuePopoverProps))
        ]
    }));
};
export default function EditPackageNameButton(param) {
    let { packageName, draft, packageId, onOpenModal } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.editPackageName');
    const onClick = ()=>{
        onOpenModal({
            width: '400px',
            shouldSubmit: async (draft)=>{
                const bundle = draft.serviceBundles().find((bundle)=>bundle.id === packageId);
                return Promise.resolve(!!(bundle === null || bundle === void 0 ? void 0 : bundle.name) && bundle.name !== packageName);
            },
            renderContent: (param)=>{
                let { setDraft } = param;
                return {
                    title: t.packageName(),
                    testId: "edit-package-name-modal",
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(PackageNameCellContent, {
                        packageName: packageName,
                        packageId: packageId,
                        draft: draft,
                        setDraft: setDraft
                    })
                };
            }
        });
    };
    return /*#__PURE__*/ _jsx(IconButton, {
        bi: {
            name: 'edit_package_name'
        },
        testId: "edit-package-name-button-".concat(packageId),
        onClick: onClick,
        children: /*#__PURE__*/ _jsx(Edit, {
            size: 18
        })
    });
}
